import { Button } from '@aon/aon-tws-common-ui';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { push } from 'react-router-redux';
import { useAppDispatch } from '../../appStore';
import ContentConstants from '../../contentConstants';
import { CardLayout, ClearDiv, ContentContainer, HeadlineSmall, InstructionsContainer, InstructionsText } from '../common';

type ConfirmationLocationState = { title: string; heading: string; text: string };

export const Confirmation = () => {
	const dispatch = useAppDispatch();
	const location = useLocation<ConfirmationLocationState>();

	return (
		<CardLayout loading={false} title={location.state.title}>
			<ContentContainer>
				<InstructionsContainer>
					<HeadlineSmall>{location.state.heading}</HeadlineSmall>
					<ClearDiv clearHeight='14px' />
					<InstructionsText>{location.state.text}</InstructionsText>
				</InstructionsContainer>
				<Button color='primary' size='lg' onClick={() => dispatch(push('/'))}>
					{ContentConstants.BUTTONS_GO_TO_SURVEY_LIST}
				</Button>
			</ContentContainer>
		</CardLayout>
	);
};
